import type { AxiosRequestConfig } from 'axios'
import merge from 'lodash.merge'

import type {
  OrderId,
  OrderLineItemId,
  OrderLineItemMutator,
} from '@beaded/models'

import * as apiUtils from '.'

const url = '/order'

export const get = (id: OrderId, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/${id}`, merge({}, options))

export const getAll = (options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/`, merge({}, options))

export const replaceCable = (
  orderId: OrderId,
  body: { previousCableId: number; newCableId: number },
) => apiUtils.POST(`${url}/${orderId}/replace-cable`, body)

export const updateOrderLineItem = (
  orderId: OrderId,
  orderLineItemId: OrderLineItemId,
  data: OrderLineItemMutator,
) => apiUtils.PUT(`${url}/${orderId}/item/${orderLineItemId}`, data)

export const getMenuProjection = (options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/`, merge({ params: { projection: 'menu' } }, options))

export const createCableForLineItem = (
  orderId: OrderId,
  lineItemId: OrderLineItemId,
) => apiUtils.POST(`${url}/${orderId}/item/${lineItemId}/create-cable`, {})

export const createFromErpnext = (erpnextRef: string) =>
  apiUtils.POST(`${url}/create-from-erpnext`, { erpnextRef })

export const resyncPlan = (id: OrderId, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/${id}/resync/plan`, merge({}, options))

export const resyncApply = (
  id: OrderId,
  body: { approvedActionIds: string[] },
) => apiUtils.POST(`${url}/${id}/resync/apply`, body)
